module.exports = __webpack_public_path__ + "static/media/house.84fa3a4c.svg";